// Card 86akj6ghg (retorno de 25/09): link escrito pelo professor na anotação
// ou no homework tem que chegar clicável ao aluno, não como texto solto.
//
// O texto é quebrado em pedaços { text } e { text, href } e o template monta
// os <a> -- nada de v-html, então o que o professor digita nunca vira HTML.

// http(s)://… ou www.… até o próximo espaço. Pontuação final ("veja
// https://x.com." ou "(https://x.com)") fica fora do link.
const URL_PATTERN = /\b(?:https?:\/\/|www\.)[^\s<>"']+/gi;
const TRAILING_PUNCTUATION = /[.,;:!?'"»”’]+$/;

function trimUrl(raw) {
  let url = raw.replace(TRAILING_PUNCTUATION, "");

  // Parêntese de fechamento só fica se abriu dentro do próprio link
  // (ex.: páginas da Wikipedia).
  while (
    url.endsWith(")") &&
    (url.match(/\(/g) || []).length < (url.match(/\)/g) || []).length
  ) {
    url = url.slice(0, -1).replace(TRAILING_PUNCTUATION, "");
  }

  return url;
}

export function linkifyParts(text) {
  const source = text == null ? "" : String(text);
  const parts = [];
  let cursor = 0;

  source.replace(URL_PATTERN, (match, offset) => {
    const url = trimUrl(match);

    if (!url || /^(https?:\/\/|www\.)$/i.test(url)) return match;

    if (offset > cursor) {
      parts.push({ text: source.slice(cursor, offset) });
    }

    parts.push({
      text: url,
      href: /^www\./i.test(url) ? `https://${url}` : url,
    });

    cursor = offset + url.length;
    return match;
  });

  if (cursor < source.length) {
    parts.push({ text: source.slice(cursor) });
  }

  return parts;
}
